import { UtilsString } from './utils-string';
import publicPathModule from '@/store/modules/public-path-module';

export class UtilsPublicResources {
    public static getImageFromImages(nombre_imagen: string) {
        return publicPathModule.publicPath + "assets/images/" + nombre_imagen;
    }
}